export interface LeadSubmission {
  name: string;
  email: string;
  phone?: string;
  company?: string;
  message: string;
  productInterest?: string;
  batchSize?: string;
  source?: string;
  website?: string;
}

interface LeadSubmissionResult {
  success: true;
  leadId: string;
  notifications: {
    queued: boolean;
  };
}

export async function submitLead(submission: LeadSubmission): Promise<LeadSubmissionResult> {
  const response = await fetch("/api/leads/notify", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(submission),
  });

  const result = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(result?.error || "We could not submit your inquiry. Please try again.");
  }

  return result as LeadSubmissionResult;
}
